function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M0 0H16V16H0V0Z",
  fill: "#016FD0"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M5.79639 13.4682V7.73486L15.9999 7.74464V9.32775L14.8204 10.5882L15.9999 11.8602V13.4771H14.1173L13.1164 12.3731L12.1226 13.4815L5.79639 13.4682Z",
  fill: "white"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M6.47754 12.84V8.36621H10.2713V9.39643H7.70598V10.096H10.21V11.1093H7.70598V11.7964H10.2713V12.84H6.47754Z",
  fill: "#016FD0"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M10.2515 12.84L12.351 10.6L10.2515 8.36621H11.8764L13.159 9.78399L14.4452 8.36621H15.9999V8.40177L13.9457 10.6L15.9999 12.776V12.84H14.4292L13.1244 11.408L11.8319 12.84H10.2515Z",
  fill: "#016FD0"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M6.27183 2.646H8.73138L9.59538 4.60777V2.646H12.6318L13.1554 4.11622L13.6807 2.646H15.9998V8.37933H3.74561L6.27183 2.646Z",
  fill: "white"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M6.73782 3.26953L4.75293 7.73975H6.11382L6.48893 6.84464H8.51826L8.88893 7.73975H10.2836L8.31026 3.26953H6.73782ZM6.90848 5.84109L7.50404 4.41886L8.09871 5.84109H6.90848Z",
  fill: "#016FD0"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M10.2686 7.73878V3.26855L12.1823 3.27567L13.1672 6.02322L14.1583 3.26855H16.0001V7.73878L14.8152 7.74944V4.67833L13.6961 7.73878H12.6143L11.4721 4.66855V7.73878H10.2686Z",
  fill: "#016FD0"
});

var SvgAmex = function SvgAmex(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAmex, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/amex.6b0d952f.svg";
export { ForwardRef as ReactComponent };